import { render, staticRenderFns } from "./QuotationPosterEdit.vue?vue&type=template&id=449b59f2&scoped=true&"
import script from "./QuotationPosterEdit.vue?vue&type=script&lang=js&"
export * from "./QuotationPosterEdit.vue?vue&type=script&lang=js&"
import style0 from "./QuotationPosterEdit.vue?vue&type=style&index=0&id=449b59f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449b59f2",
  null
  
)

export default component.exports